import axios from 'axios';
import config from '../config/config';

const instance = axios.create({
  baseURL: config.apiRoute,
});

instance.interceptors.request.use(
  (axiosConfig) => {
    let { baseURL } = axiosConfig;

    if (window.Widget.settings.hostname) {
      baseURL = `${window.Widget.settings.hostname.replace('//', '//widget-api.')}/api/`;
    }

    return {
      ...axiosConfig,
      baseURL,
    };
  },
  (error) => Promise.reject(error),
);

export default instance;
